import { Component, Input, OnDestroy, OnInit, Renderer2 } from '@angular/core';
import { Store } from '@ngrx/store';
import { MessageService } from 'primeng/api';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { AppState } from 'src/app/app.state';
import { CustomScriptInjectionService } from 'src/app/modules/shared/services/custom-script-injection.service';
import { SettingService } from 'src/app/modules/shared/services/setting.service';

@Component({
  selector: 'app-login-screen',
  templateUrl: './login-screen.component.html',
  styleUrls: ['./login-screen.component.css']
})
export class LoginScreenComponent implements OnInit, OnDestroy {

  @Input() adminMode: boolean;
  rememberLogin: boolean;
  protected destroyActions = new Subject<boolean>();

  constructor(private messageService: MessageService, private store: Store<AppState>,
    private customScriptService: CustomScriptInjectionService, private renderer: Renderer2,
    private settingService: SettingService) { }

  ngOnInit(): void {
    this.settingService.isEnableCustomizationPerPage()
      .pipe(takeUntil(this.destroyActions))
      .subscribe(res => {
        if(res){
          this.customScriptService.loadAndRunCustomScriptBlock(this.renderer, document, 'login');
        }
    });
  }

  showError(msg: string): void {
    this.messageService.add({ severity: 'error', summary: $localize`Login Error`, detail: msg, closable: false });
  }

  ngOnDestroy(): void {
    this.customScriptService.removeTrackedElements();
    this.destroyActions.next();
    this.destroyActions.complete();

  }
}
